import { Trans } from '@mbarzda/solid-i18next'
import { Show, createSignal, onMount, type Component } from 'solid-js'

export interface TableHeaderCellProps {
  readonly id: string
  readonly tableId: string
  readonly status?: 'asc' | 'desc'
  readonly setOrderBy: (id: string) => void
  readonly withHint?: boolean
  readonly sortable?: boolean
  /** Explicit translation key for the header label. Defaults to `ls_table_{tableId}_col_{id}`. */
  readonly labelKey?: string
}

const TableHeaderCell: Component<TableHeaderCellProps> = (props) => {
  const [svgWidth, setSvgWidth] = createSignal(0)
  let svgRef: HTMLDivElement

  onMount(() => {
    setTimeout(() => {
      const width = svgRef.clientWidth
      setSvgWidth(width + 4)
    }, 1000)
  })

  return (
    <div
      class="group inline-flex relative whitespace-nowrap items-center text-sm"
      classList={{ 'cursor-pointer': props.sortable }}
      onClick={() => {
        props.sortable && props.setOrderBy(props.id)
      }}
    >
      <div class="grid text-black font-medium" ref={(el) => (svgRef = el)}>
        <Trans key={props.labelKey ?? `ls_table_${props.tableId}_col_${props.id}`} />
        <Show when={props.withHint}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={svgWidth()}
            height="2"
            viewBox={`0 0 ${svgWidth()} 2`}
            fill="none"
          >
            <path d={`M0 1H${svgWidth()}`} stroke="#6B7280" stroke-linejoin="round" stroke-dasharray="2 4" />
          </svg>
        </Show>
      </div>
      <Show when={props.sortable}>
        <span
          class="ml-2 h-5 flex-none rounded"
          classList={{
            'text-gray-900': !!props.status,
            'invisible text-gray-400 group-hover:visible group-focus:visible': !props.status
          }}
        >
          <svg
            class="h-5 w-5"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
            style={{
              transform: props.status === 'asc' ? 'rotate(180deg)' : 'none'
            }}
          >
            <path
              fill-rule="evenodd"
              d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
              clip-rule="evenodd"
            />
          </svg>
        </span>
      </Show>
    </div>
  )
}

export default TableHeaderCell
